export const environment = {
  production: true,
  env: 'staging',
  // API_URL: 'https://stagingapi.homhero.com.au/',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  API_URL: 'https://api.staging.homhero.com.au/',
};
